/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { Fragment, useEffect, useRef, useState } from 'react'
import { Button, Checkbox, FormControlLabel, Grid, Tooltip, Typography } from '@mui/material'
import { FnBlock_UI } from 'service/SystemFunction/SystemFunction';
import { GridColumns } from '@mui/x-data-grid-pro';
import InnerHeadRoutes from 'components/Common/InnerHeadRoutes/InnerHeadRoutes';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import Accordion from 'components/Common/Accordion/Accordion';
// yup
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { FormProvider, useForm } from 'react-hook-form';
import yupFormSchemas from 'components/Common/FormItem/yup/yupFormSchemas';

import { SnackbarCustom } from 'components/Common/Alert/Snackbars/Snackbar';
import { AlertTitleTh, AxiosGet, AxiosPost, AxiosPostFileExcel, Extension, ResultAPI } from 'service/CommonFunction/TS_function';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import UploadFile from 'components/Common/ElementInForm/UploadFile/UploadFile';
import AutoCompleteSelect from 'components/Common/ElementInForm/AutoCompleteSelect';
import TbComplain from './components/TbComplain';
import moment from 'moment';
import { BtnAddForm, BtnExportExcel, BtnIconSearch, BtnSend } from 'components/Common/Button';
import { SwAlert } from 'components/Common/Alert/AlertForm';
import TbRequest from './components/TbRequest';
import TbSuggestion from './components/TbSuggestion';


const ImportInfo = () => {

    const { BlockUI, UnBlockUI } = FnBlock_UI();

    const onClearImportFile = useRef(null);
    const [lstJobType, setlstJobType] = useState([] as any)
    const [arrImport, setarrImport] = useState([] as any)
    const [DataRow, setDataRow] = useState([] as any)
    const [nAllCount, setnAllCount] = useState(0)
    const [nNotPassCount, setnNotPassCount] = useState(0)
    const [nPassCount, setnPassCount] = useState(0)
    const [isLoadingTable, setisLoadingTable] = useState(false)
    const [isAfterSubmit, setisAfterSubmit] = useState(false)
    const [isSelectType, setisSelectType] = useState(false)
    //SnankBar
    const [IsOpenSnackbar, setIsOpenSnackbar] = useState(false)
    const [sSeveritySnackbar, setsSeveritySnackbar] = useState("success")
    const [sMessageSnackbar, setsMessageSnackbar] = useState(null) as any

    const schema = yup.object().shape({
        oJobType: yupFormSchemas.object("ประเภทข้อมูล", { required: false }),
    });
    const form = useForm({
        resolver: yupResolver(schema),
        mode: 'all',
        shouldFocusError: true,
        criteriaMode: "firstError"
    })

    useEffect(() => {
        GetJobType();
    }, [])

    useEffect(() => {
        if(arrImport.length > 0)
        {
            onAddImportData();
        }
    }, [isSelectType,arrImport])

    const GetJobType = () => {
        AxiosGet(`MasterData/GetVOCJobType`, { "IsSuggest": true }, (res) => {
            ResultAPI(res, null, () => {
                let option = res.result?.data
                if (option.length !== 0) {
                    setlstJobType(option)
                    form.setValue("oJobType", option[0])
                }
            })
        });
    }

    const onHandleExportTemplate = (sTypeJob) => {
        let sFileName = "";
        let sMethodAPI = "";
        let sParamAPI = null;
        switch (sTypeJob) {
            case "1":
                sFileName = `Complaint_Template_${moment().format("DDMMYYYYHHmmss")}`;
                sMethodAPI = "ImportData/ExportTemplateComplaint";
                break;
            case "2":
                sFileName = `Request_Template_${moment().format("DDMMYYYYHHmmss")}`;
                sMethodAPI = "ImportData/ExportTemplateRequest";
                break;
            case "3":
                sFileName = `Suggestion_Template_${moment().format("DDMMYYYYHHmmss")}`;
                sMethodAPI = "ImportData/ExportTemplateSuggestion";
                break;
        }
        AxiosPostFileExcel(sMethodAPI, sParamAPI, sFileName, null, null, BlockUI, UnBlockUI)
    }

    const onAddImportData = () => {
        let param = {
            lstFile: arrImport,
        }
        let sMethodAPI = "";
        let formJobType = form.getValues("oJobType")?.value;

        switch (formJobType) {
            case "1":
                sMethodAPI = "ImportData/ImportDataComplaint";
                break;
            case "2":
                sMethodAPI = "ImportData/ImportDataRequest";
                break;
            case "3":
                sMethodAPI = "ImportData/ImportDataSuggestion";
                break;
        }

        BlockUI();
        AxiosPost(sMethodAPI, param, (res) => {
            UnBlockUI();
            ResultAPI(res, null, () => {
                setisAfterSubmit(false)
                if (res.Message == "Success" && res.lstData != null) {
                    setIsOpenSnackbar(true);
                    setsMessageSnackbar("อัปโหลดไฟล์สำเร็จ")
                    setsSeveritySnackbar("success")
                    setDataRow(res.lstData)
                    setnAllCount(res.nAll)
                    setnNotPassCount(res.nNotPass)
                    setnPassCount(res.nPass)
                    onClearImportFile.current(null)
                }
                else {
                    setDataRow([])
                    setnAllCount(0)
                    setnNotPassCount(0)
                    setnPassCount(0)
                    setIsOpenSnackbar(true);
                    setsMessageSnackbar(res.Message)
                    setsSeveritySnackbar("warning")
                }
            })
        });
    }

    const onSubmitImportData = () => {
        let formJobType = form.getValues("oJobType")?.value;
        let param = {
            lstdata: DataRow,
            nJobType: parseInt(formJobType),
        }
        let sMessage = "คุณต้องการที่จะยืนยันนำเข้าข้อมูลใช่หรือไม่ ?"

        SwAlert.Confirm(AlertTitleTh.Confirm, sMessage, () => {
            BlockUI();
            AxiosPost(`ImportData/SaveVOCFormDataForImport`, param, (res) => {
                UnBlockUI();
                ResultAPI(res, null, () => {
                    if (res.Message == "Success" && res.lstdata != null) {
                        setisAfterSubmit(true)
                        setIsOpenSnackbar(true);
                        setsMessageSnackbar("นำเข้าข้อมูลสำเร็จ")
                        setsSeveritySnackbar("success")
                        setDataRow(res.lstdata)
                    }
                    else {
                        setIsOpenSnackbar(true);
                        setsMessageSnackbar(res.Message)
                        setsSeveritySnackbar("warning")
                    }
                })
            });
        })
    }

    const ExportExcelImportResult =()=>{
        let formJobType = form.getValues("oJobType")?.value;

        let sFileName = "";
        let sMethodAPI = "ImportData/ExportDataImport";
        let param = {
            lstdata: DataRow,
            nJobType: parseInt(formJobType),
        }
        switch (formJobType) {
            case "1":
                sFileName = `Importdata_Complaint_${moment().format("DDMMYYYYHHmmss")}`;
                break;
            case "2":
                sFileName = `Importdata_Request_${moment().format("DDMMYYYYHHmmss")}`;
                break;
            case "3":
                sFileName = `Importdata_Suggestion_${moment().format("DDMMYYYYHHmmss")}`;
                break;
        }
        AxiosPostFileExcel(sMethodAPI, param, sFileName, null, null, BlockUI, UnBlockUI)
    }

    return (
        <>
            <InnerHeadRoutes
                iconMUI={<ManageAccountsIcon style={{ fontSize: '1.5em' }} />}
                labal_Head="ผู้ดูแลระบบ"
                label_nameRoute="นำเข้าข้อมูล"
            />
            <Grid container spacing={2} direction="row" justifyContent="center" alignItems="center" style={{ marginTop: '0' }}>
                <Grid item xs={12}>
                    <Accordion header={"Dowload Template"}>
                        <Grid container spacing={3} direction="row" justifyContent="start" alignItems="center">
                            {
                                lstJobType.length > 0 ?
                                    <>
                                        {
                                            lstJobType.map((itm, ind) => {
                                                let sKey = itm?.value + ind
                                                return (
                                                    <Fragment key={sKey}>
                                                        <Grid item xs={'auto'}>
                                                            <Tooltip title={itm.label}>
                                                                <Button
                                                                    startIcon={<FileDownloadIcon style={{ color: "#ffffff" }} />}
                                                                    variant="contained"
                                                                    size='large'
                                                                    onClick={() => { onHandleExportTemplate(itm.value) }}
                                                                    sx={{
                                                                        color: "#fff",
                                                                        backgroundColor: "#26b6ef",
                                                                        ":hover": { bgcolor: "#169bd5" },
                                                                    }}
                                                                >
                                                                    {itm.label}
                                                                </Button>
                                                            </Tooltip>
                                                        </Grid>
                                                    </Fragment>
                                                )
                                            })
                                        }
                                    </>
                                    : null
                            }
                        </Grid>
                    </Accordion>
                </Grid>
                <Grid item xs={12}>
                    <Accordion header={"Import"}>
                        <Grid container spacing={2} direction="row" justifyContent="start" alignItems="center">
                            <Grid item xs={12}>
                                <FormProvider {...form}>
                                    <Grid container spacing={2} direction="row" justifyContent="start" alignItems="center">
                                        <Grid item xs={12} md={4}>
                                            <AutoCompleteSelect
                                                name="oJobType"
                                                options={lstJobType}
                                                label={"ประเภทข้อมูล"}
                                                required={true}
                                                disableClearable={true}
                                                onChange={()=>{
                                                    setisSelectType(!isSelectType)
                                                    setDataRow([])
                                                }}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={'auto'}>
                                            <UploadFile
                                                id="sFileImport"
                                                keyID={1}
                                                sTitle={"File Import"}
                                                IsRequired={false}
                                                arrFile={arrImport || []}
                                                setarrFile={setarrImport}
                                                IsFolder={false}
                                                IsFile={true}
                                                IsMultiple={false}
                                                Extension={[...Extension.Excel]}
                                                IsDrag={false}
                                                nLimitFile={10}
                                                sLimitFile={"MB"}
                                                onClearFile={onClearImportFile}
                                            />
                                        </Grid>
                                        {/* <Grid item xs={12} md={'auto'}>
                                            <BtnIconSearch onClick={() => { onAddImportData() }} />
                                        </Grid> */}
                                    </Grid>
                                </FormProvider>
                            </Grid>
                            <Grid item xs={12} style={{ display: DataRow.length === 0 ? 'none' : 'block' }}>
                                <Grid container spacing={2} direction="row" justifyContent="space-between" alignItems="center">
                                    <Grid item>
                                        <Grid container spacing={2} direction="row" justifyContent="start" alignItems="center">
                                            <Grid item><Typography>จำนวนแถวทั้งหมด : {nAllCount}</Typography></Grid>
                                            <Grid item><Typography>จำนวนแถวที่ผ่าน : {nPassCount}</Typography></Grid>
                                            <Grid item><Typography>จำนวนแถวที่ไม่ผ่าน : {nNotPassCount}</Typography></Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid item style={{display: isAfterSubmit == true ? 'block' : 'none'}}>
                                        <BtnExportExcel onClick={()=>{ExportExcelImportResult()}} />
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item xs={12}>
                                <Grid container spacing={2} direction="row" justifyContent="center" alignItems="center">
                                    {
                                        form.getValues("oJobType") != null && form.getValues("oJobType").value == "3"
                                            ?
                                            <Grid item xs={12}>
                                                <TbSuggestion
                                                    DataRow={DataRow}
                                                    isLoadingTable={isLoadingTable}
                                                    isAfterSubmit={isAfterSubmit}
                                                />
                                            </Grid>
                                            :
                                            form.getValues("oJobType") != null && form.getValues("oJobType").value == "2"
                                                ?
                                                <Grid item xs={12}>
                                                    <TbRequest
                                                        DataRow={DataRow}
                                                        isLoadingTable={isLoadingTable}
                                                        isAfterSubmit={isAfterSubmit}
                                                    />
                                                </Grid>
                                                :
                                                <Grid item xs={12}>
                                                    <TbComplain
                                                        DataRow={DataRow}
                                                        isLoadingTable={isLoadingTable}
                                                        isAfterSubmit={isAfterSubmit}
                                                    />
                                                </Grid>
                                    }
                                    <Grid item >
                                        <BtnSend
                                            txt='ยืนยันนำเข้าข้อมูล'
                                            isDisabled={nNotPassCount != 0 || DataRow.length == 0}
                                            onClick={() => { onSubmitImportData() }}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Accordion>
                </Grid>
            </Grid>
            <SnackbarCustom
                IsOpen={IsOpenSnackbar}
                Severity={sSeveritySnackbar}
                OnClose={() => { setIsOpenSnackbar(false) }}
                Message={sMessageSnackbar}
            />
        </>
    )
}

export default ImportInfo